import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  deleteTarget({ params: { deletionTarget } }) {
    document.querySelector(deletionTarget).remove();
  }
}
